import ClaimCostTemplateLink from '@components/shared/claim/emailPreview/ClaimCostTemplateLink';
import React from 'react';
const ClaimCostTemplateLinks = _ref => {
  let {
    claimGroup
  } = _ref;
  return claimGroup.claims.map(claim => /*#__PURE__*/React.createElement(ClaimCostTemplateLink, {
    claim: claim
  }));
};
export default ClaimCostTemplateLinks;